import React, {useState} from "react";
import {useSelector} from "react-redux";
import {Button, Layout} from "antd";
import Overview from "./form/Overview";
import Details from "./form/Details";
import Venue from "./form/Venue";
import Rewards from "./form/Rewards";
import Hosts from "./form/Hosts";
import axiosData from "../../../helpers/axiosData";
import { toast } from "react-toastify";
import { redirectTo } from "../../../config/CoreMethods";
import { ROUTES } from "../../../config/constants";

const { Content } = Layout;

const EventsForm = () => {
    const selector = useSelector
    let activeStep = selector ((state) => state.event.activeStep)
    let formData = selector ((state) => state.event.formData)
    const [loadingBtn, setLoadingBtn] = useState({
        active: false,
        type: 0,
    });


    const saveEvent = (is_submit) => {
        
        let form_data = new FormData();
        let Form = formData;
        setLoadingBtn({active: true, type: is_submit})

        console.log('formData', formData);
        console.log('Form', Form);

        if (Object.keys(Form).length > 0) 
        {
            for (const k in Form) {
                // console.log( "\n k",k,', Form[k]',Form[k] , ' Object.hasOwnProperty.call(Form, k)', Object.hasOwnProperty.call(Form, k) )
                // console.log( '&&-', "k != 'ticket_type'", k != 'ticket_type')
                // console.log( '&& (-', "(Array.isArray(Form[k]) && Form[k].length>0)", (Array.isArray(Form[k]) && Form[k].length>0))
                // console.log( '|| ', "(Form[k] != '' && Form[k] != 0) -)", (Form[k] != '' && Form[k] != 0))
                // console.log( '|| 4-', "k === 'ticket_type'", k === 'ticket_type')

                
                // if (Object.hasOwnProperty.call(Form, k)  &&   (k != 'ticket_type' && ((Array.isArray(Form[k]) && Form[k].length>0) || (Form[k] != '' && Form[k] != 0)))   || k==='ticket_type' ) 
                if (Object.hasOwnProperty.call(Form, k) )  
                {
                    if (k ==='start_date' && Form.start_date!='') {
                        
                        form_data.append('start_date', Form.start_date+' '+Form.start_time+':00'); 

                    } else if (k ==='end_date' && Form.end_date!='') {
                        
                        form_data.append('end_date', Form.end_date+' '+Form.end_time+':00'); 

                    } else if (k ==='Hosts' && Form.Hosts.length) {
                        
                        let ids = [];
                        for(let i=0; i<Form.Hosts.length; i++) {
                            ids.push(Form.Hosts.id)
                        }
                        form_data.append('hosts', ids); 
                        
                    } else {
                        form_data.append(k, Form[k]); 
                    }
                }
            }
        }

        form_data.append('approved', is_submit); 

        let Url = formData.id ? 'update/'+formData.id : 'create';

        axiosData.post("/api/_web3/event/" + Url, form_data).then((res) => {
            
            console.log('res.data', res.data)
            setLoadingBtn({active: false, type: is_submit})

            if (res.data.success) {

                redirectTo(ROUTES.myEvents.path)
                toast.success('Approved')

            } else {
                toast.error(res.data.message)
            }
        }).catch(er => {
            setLoadingBtn({active: false, type: is_submit})
            toast.error('OOPS! Something went wrong.')
        })

    }

    const switchStepComponents = (key) => {
        switch (key) {
            case 'overview':
                return (<Overview
                    formTitle="Overview"
                    formDesc="Something about overview step"
                />);
            case 'details':
                return (<Details
                    formTitle="Event Details"
                    formDesc="Strive to present event details in a concise and captivating manner."
                />);
            case 'venue':
                return (<Venue
                    formTitle="Venue"
                    formDesc="Please specify the event's location. You have the option to host the event at your own venue or book a different location."
                />);
            case 'rewards':
                return (<Rewards
                    formTitle="Reward Pool"
                    formDesc="You can designate rewards to motivate event participants. If you own a Metahut, then you can create a reward pool for the event using your own NFTs and tokens."
                    formTitle1="Tickets"
                    formDesc1="You can set a ticket price for event participation. If you are a Metahut owner, you can utilize your own NFTs and tokens to assign value to event tickets."
                />);
            case 'hosts':
                return (<Hosts
                    formTitle="Hosts"
                    formDesc="You can add users to manage events. The event host will have the ability to modify all information about the event."
                    formTitle1="Contact Details"
                    formDesc1="Please provide your contact information so that we can get in touch with you."
                />);
            default:
                break;
        }
    };



    return (
        <Content className="font-mont eform" id={activeStep}>
            <div className="eform-header">
                {activeStep === 'overview' &&
                    <div className="back-nav">
                        <i className="icon-back"></i>
                        <span>Back</span>
                    </div>
                }
                <div className="eform-act">
                    <div className="eform-act_info">
                        <h3 className="eform-act_ttl">Save or Submit for Review</h3>
                        <p className="eform-act_desc">Your event submission will be reviewed by our team, and you will be notified using the contact details provided.</p>
                    </div>
                    <div className="eform-act_btn">
                        <Button onClick={() => { saveEvent(0) }} className="save-btn">
                            {loadingBtn.active && loadingBtn.type == 0 ? <span className="loading-btn"></span> : ""}
                            Save
                        </Button>
                        <Button onClick={() => { saveEvent(1) }} className="submit-btn">
                            {loadingBtn.active && loadingBtn.type == 1 ? <span className="loading-btn"></span> : ""}
                            Submit
                        </Button>
                    </div>
                </div>
            </div>
            <div className="line-x"></div>
            <div className="eform-content">
                {switchStepComponents(activeStep)}
            </div>
        </Content>
    )
}

export default EventsForm;